// extracted by mini-css-extract-plugin
export default {"hideTooltip":"R--z","fadeIn":"S--z","delay":"T--z","recommendedSizeTooltip":"U--z"};